import {
  DocumentType,
  LastFileView,
  ObjectCFV,
  CustomField
} from '../index';

declare var Object: any;
export interface LastDocumentInterface {
  "expDate"?: any;
  "expField"?: string;
  "documentTypeId": number;
  "objectType": string;
  "objectId": number;
  "name": string;
  "id": number;
  "ownerId": number;
  "notes"?: string;
  "meta": any;
  "ctime": Date;
  "utime": Date;
  "dtime"?: Date;
  "dtime_str"?: string;
  documentType?: DocumentType;
  forObject?: any;
  lastFile?: LastFileView;
  customFieldValues?: ObjectCFV[];
  customFields?: CustomField[];
}

export class LastDocument implements LastDocumentInterface {
  "expDate": any;
  "expField": string;
  "documentTypeId": number;
  "objectType": string;
  "objectId": number;
  "name": string;
  "id": number;
  "ownerId": number;
  "notes": string;
  "meta": any;
  "ctime": Date;
  "utime": Date;
  "dtime": Date;
  "dtime_str": string;
  documentType: DocumentType;
  forObject: any;
  lastFile: LastFileView;
  customFieldValues: ObjectCFV[];
  customFields: CustomField[];
  constructor(data?: LastDocumentInterface) {
    Object.assign(this, data);
  }

  /**
   * The name of the model represented by this $resource,
   * i.e. `LastDocument`.
   */
  public static getModelName() {
    return "LastDocument";
  }

  /**
  * This method creates an instance of LastDocument for dynamic purposes.
  **/
  public static factory(data: LastDocumentInterface): LastDocument{
    return new LastDocument(data);
  }

  /**
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'LastDocument',
      plural: 'LastDocuments',
      path: 'LastDocuments',
      idName: 'id',
      properties: {
        "expDate": {
          name: 'expDate',
          type: 'any'
        },
        "expField": {
          name: 'expField',
          type: 'string'
        },
        "documentTypeId": {
          name: 'documentTypeId',
          type: 'number'
        },
        "objectType": {
          name: 'objectType',
          type: 'string'
        },
        "objectId": {
          name: 'objectId',
          type: 'number'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "ownerId": {
          name: 'ownerId',
          type: 'number'
        },
        "notes": {
          name: 'notes',
          type: 'string'
        },
        "meta": {
          name: 'meta',
          type: 'any'
        },
        "ctime": {
          name: 'ctime',
          type: 'Date'
        },
        "utime": {
          name: 'utime',
          type: 'Date'
        },
        "dtime": {
          name: 'dtime',
          type: 'Date'
        },
        "dtime_str": {
          name: 'dtime_str',
          type: 'string'
        },
      },
      relations: {
        documentType: {
          name: 'documentType',
          type: 'DocumentType',
          model: 'DocumentType',
          relationType: 'belongsTo',
                  keyFrom: 'documentTypeId',
          keyTo: 'id'
        },
        forObject: {
          name: 'forObject',
          type: 'any',
          model: '',
          relationType: 'belongsTo',
                  keyFrom: 'objectId',
          keyTo: 'id'
        },
        lastFile: {
          name: 'lastFile',
          type: 'LastFileView',
          model: 'LastFileView',
          relationType: 'hasOne',
                  keyFrom: 'id',
          keyTo: 'documentId'
        },
        customFieldValues: {
          name: 'customFieldValues',
          type: 'ObjectCFV[]',
          model: 'ObjectCFV',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'objectId'
        },
        customFields: {
          name: 'customFields',
          type: 'CustomField[]',
          model: 'CustomField',
          relationType: 'hasMany',
          modelThrough: 'ObjectCFV',
          keyThrough: 'customFieldId',
          keyFrom: 'id',
          keyTo: 'objectId'
        },
      }
    }
  }
}
